import React from 'react';

interface Props {
  in: boolean;
  onClick?: () => void;
}

const PageOverlay: React.FC<Props> = (props) => {
  return (
    <div
      onClick={props.onClick}
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        bottom: 0,
        height: '100%',
        left: 0,
        opacity: props.in ? 1 : 0,
        position: 'absolute',
        right: 0,
        top: 0,
        transition: 'opacity 0.15s ease-out',
        visibility: props.in ? 'visible' : 'hidden',
        width: '100%',
        // Less z-index than $zindex-navbar-fixed, which needs to be visible above the overlay,
        // and more than the sticky hero bar and section nav, which have z-index of 1000.
        zIndex: 1020
      }}
    />
  );
};

export default PageOverlay;
